import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cta", "form", "input"]

  declare readonly ctaTarget: HTMLElement
  declare readonly formTarget: HTMLElement
  declare readonly hasInputTarget: boolean
  declare readonly inputTarget: HTMLInputElement

  show() {
    this.ctaTarget.hidden = true
    this.formTarget.hidden = false
    if (this.hasInputTarget) this.inputTarget.focus()
  }

  hide() {
    this.formTarget.hidden = true
    this.ctaTarget.hidden = false
    if (this.hasInputTarget) this.inputTarget.value = ""
  }
}
